// eslint-disable-next-line import/prefer-default-export
export enum PaymentStatus {
  Succeeded = 'SUCCEEDED',
  Authorised = 'AUTHORISED',
}

export const paymentSuccessStatuses = [PaymentStatus.Succeeded, PaymentStatus.Authorised];
